import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'hour'
})

export class HourPipe implements PipeTransform {
    transform(val) {
      return val.replace(/^0+| 0/g, ' ');
    }
}
